import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { AudioProvider } from './context/AudioContext';
import Navigation from './components/Navigation';
import AudioPlayer from './components/AudioPlayer';
import Home from './pages/Home';
import Cinema from './pages/Cinema';
import TvWeb from './pages/TvWeb';
import Musique from './pages/Musique';
import Studio from './pages/Studio';
import Tournage from './pages/Tournage';
import Bio from './pages/Bio';
import Photos from './pages/Photos';
import PhotoAdmin from './pages/PhotoAdmin';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import { Toaster } from './components/ui/sonner';
import Footer from './components/Footer'; // ⬅️ NEW
import SwipeNavigation from './components/SwipeNavigation';

// Composant interne pour accéder à useLocation
function AnimatedRoutes() {
  const location = useLocation();

  // Scroll vers le haut à chaque changement de page
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home key="home" />} />
        <Route path="/cinema" element={<Cinema />} />
        <Route path="/tvweb" element={<TvWeb />} />
        <Route path="/musique" element={<Musique />} />
        <Route path="/studio" element={<Studio />} />
        <Route path="/admin-photos" element={<PhotoAdmin />} />
        <Route path="/tournage" element={<Tournage />} />
        <Route path="/bio" element={<Bio />} />
        <Route path="/photos" element={<Photos />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/actualites" element={<Blog />} />
        <Route path="/actualites/:slug" element={<BlogPost />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <AudioProvider>
      <div className="App">
        <BrowserRouter>
          <Navigation />
          <SwipeNavigation />
          <AudioPlayer />
          <AnimatedRoutes />
          <Footer /> {/* ⬅️ NEW: pied de page global */}
          <Toaster />
        </BrowserRouter>
      </div>
    </AudioProvider>
  );
}

export default App;
